<script lang="ts">
    import { _ } from 'svelte-i18n';
    import type { ImportAnalyzeContextReasonType, ImportAnalyzeResponseType } from '../../ColumnSelectPro/ColumnSettingsApi';
    import ImportAnalyzeRow from './ImportAnalyzeRow.svelte';
    import { currentImport } from '../../../shared/ColumnSelectPro/currentImport';
    import { importFileTypeItems, importMethodTypeItems } from '../Import';
    import Switch from '../../../shared/Switch.svelte';
    import ImportAnalyzeByCategory from './ImportAnalyzeByCategory.svelte';
    import { debug } from '../../../../stores/store';
    import ImportAnalyzeResolveLinks from './ImportAnalyzeResolveLinks.svelte';
    import ImportAnalyzeRowInfo from './ImportAnalyzeRowInfo.svelte';

    export let analyze: ImportAnalyzeResponseType;
    export let reloadAnalyze: () => void;
    export let agreeToImportWithoutInvalidRows: boolean;

    let errors: ImportAnalyzeContextReasonType[] = [];

    let showByCategory: boolean = $currentImport?.file_type === 'locations';
    let showUploadedIgnored: boolean = false;

    // Oba `label` z Import.ts to klucze i18n — `Select.svelte` tłumaczy je sam, tutaj trzeba jawnie.
    let labelImportFileType = importFileTypeItems.find(item => item.id === $currentImport?.file_type)?.label || '';

    let labelImportMethodType = importMethodTypeItems.find(item => item.id === $currentImport?.import_type)?.label || '';

    function onFinish() {
        reloadAnalyze();
    }
</script>

<div class="import-analyze-container">
    <div class="import-analyze-section">
        <ImportAnalyzeRowInfo label={$_('Type of imported data')} count={labelImportFileType ? $_(labelImportFileType) : ''} />
        <ImportAnalyzeRowInfo label={$_('Import type')} count={labelImportMethodType ? $_(labelImportMethodType) : ''} />
        <ImportAnalyzeRowInfo label={$_('File name')} count={$currentImport?.filename || ''} />
    </div>
    <div class="import-analyze-section">
        <div style="display: flex; justify-content: flex-end; width: 100%;">
            <Switch bind:checked={showByCategory} label={$_('by category')} disabled={$currentImport?.file_type !== 'locations'} />
        </div>
        <ImportAnalyzeByCategory {analyze} {showByCategory} />
    </div>
    <div class="import-analyze-section">
        {#if $currentImport?.file_type === 'locations'}
            <ImportAnalyzeRow label={$_('Jobs with addresses')} context={analyze.added_by_address} />
            <ImportAnalyzeRow label={$_('Jobs with x,y coordinates')} context={analyze.added_by_coords} />
            <ImportAnalyzeRow label={$_('Jobs with coordinates from link')} context={analyze.added_by_xy} />
            <ImportAnalyzeRow label={$_('Jobs with links to decode')} context={analyze.needed_to_resolve_from_link} displayType="warning">
                <ImportAnalyzeResolveLinks {analyze} {onFinish} bind:errors />
            </ImportAnalyzeRow>
            <ImportAnalyzeRow label={$_('All jobs in the uploaded file')} context={analyze.total_uploaded} />
            <ImportAnalyzeRow
                label={$_('Ignored/invalid jobs')}
                context={analyze.uploaded_ignored}
                comment={$_('invalid data')}
                displayType="problem"
                displayReasons={true}
            ></ImportAnalyzeRow>
        {/if}
        {#if $currentImport?.file_type === 'connections'}
            <ImportAnalyzeRow label={$_('All connections in the uploaded file')} context={analyze.total_uploaded} />
            <ImportAnalyzeRow
                label={$_('Ignored/invalid connections')}
                context={analyze.uploaded_ignored}
                comment={$_('invalid data')}
                displayType="problem"
                displayReasons={true}
            ></ImportAnalyzeRow>
        {/if}
    </div>
    <!--        -->
    <!--        <ImportAnalyzeRow-->
    <!--            label="Wszystkich wierszy we wgranym pliku"-->
    <!--            count={analyze.total_uploaded.count}-->
    <!--            values={analyze.total_uploaded.values}-->
    <!--        />-->
    <!--        <ImportAnalyzeRow-->
    <!--            label="Wiersze zignorowane"-->
    <!--            count={analyze.uploaded_ignored.count}-->
    <!--            values={analyze.uploaded_ignored.values}-->
    <!--            warning={analyze.uploaded_ignored.count > 0}-->
    <!--        />-->
    <!--        <div style="display: flex; flex-direction: row; align-items: center; column-gap: 16px;">-->
    <!--            <ImportAnalyzeRow-->
    <!--                label="Wiersze wadliwe"-->
    <!--                count={analyze.invalid.count}-->
    <!--                values={analyze.invalid.values}-->
    <!--                warning={analyze.invalid.count > 0}-->
    <!--            />-->
    <!--            {#if analyze.invalid.count > 0}-->
    <!--                <Switch bind:checked={showUploadedIgnored} label="Pokaż" disabled={false} />-->
    <!--                &lt;!&ndash;                <Checkbox&ndash;&gt;-->
    <!--                &lt;!&ndash;                    bind:checked={agreeToImportWithoutInvalidRows}&ndash;&gt;-->
    <!--                &lt;!&ndash;                    label="Chcę kontynuować import bez wadliwych wierszy"&ndash;&gt;-->
    <!--                &lt;!&ndash;                />&ndash;&gt;-->
    <!--            {/if}-->
    <!--        </div>-->
    <!--    {#if analyze.invalid.count > 0}-->
    <!--        <div style="width: 100%;">-->
    <!--            {#if showUploadedIgnored}-->
    <!--                <div style="display: flex; max-height: 120px; overflow: auto; flex-direction: column;">-->
    <!--                    {#each analyze.invalid.reasons as value, index}-->
    <!--                        <div>-->
    <!--                            <ErrorColor>-->
    <!--                                <UploadedIgnoredReason reason={value} />-->
    <!--                            </ErrorColor>-->
    <!--                        </div>-->
    <!--                    {/each}-->
    <!--                </div>-->
    <!--            {/if}-->
    <!--        </div>-->
    <!--    {/if}-->
    <!--</div>-->
    <!--{#if analyze.invalid.count === 0}-->
    <!--    <div class="import-analyze-section">-->
    <!--        <ImportAnalyzeRow-->
    <!--            label="Liczba elementów po imporcie"-->
    <!--            count={analyze.count_items_after_import}-->
    <!--            warning={analyze.count_items_after_import === 0}-->
    <!--        />-->
    <!--    </div>-->
    <!--{/if}-->
    {#if $debug}
        <code>
            {JSON.stringify(analyze.unchanged, null, 2)}
        </code>
    {/if}
</div>

<style>
    .import-analyze-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        width: 100%;
        font-size: var(--font-size-tactical-plan);
        row-gap: 35px;
    }
    .import-analyze-section {
        display: flex;
        flex-direction: column;
        row-gap: 10px;
        justify-content: center;
        align-items: flex-start;
        width: 100%;
    }
</style>
